import { useFormContext } from "react-hook-form";
import { TextFieldProps } from "./Text.types";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { Input } from "@shadcn/components/ui/input";
import { Textarea } from "@shadcn/components/ui/textarea";
import { Label } from "@shadcn/components/ui/label";
import { getValidationConfig } from "@forms/form-render/helpers/getValidationConfig";
import { getFieldHelperText } from "@forms/form-render/helpers/getFieldHelperText";

export const Text = ({ label, name, required, validation, config, disabled }: TextFieldProps) => {
  const { control } = useFormContext();
  const validationConfig = getValidationConfig(validation);
  const description = getFieldHelperText(config.helperText, required);

  return (
    <FormField
      control={control}
      defaultValue={config.defaultValue}
      rules={{
        ...validationConfig,
        required: {
          value: required,
          message: "This is a required field",
        },
      }}
      name={name}
      render={({ field }) => (
        <FormItem className="space-y-2">
          {label && <Label htmlFor={name}>{label}</Label>}
          <FormMessage />
          <FormControl>
            {config.multiline ? (
              <Textarea {...field} id={name} placeholder={config.placeholder} disabled={disabled} aria-label={label} />
            ) : (
              <Input {...field} id={name} placeholder={config.placeholder} disabled={disabled} aria-label={label} />
            )}
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
        </FormItem>
      )}
    />
  );
};
